import LandForm from './land-form/land-form.vue'; // 耕地
import sihuangForm from './sihuang-form/sihuang-form.vue'; // 四荒
import WoodsForm from './woods-form/woods-form.vue'; // 林地
import WaterForm from './water-form/water-form.vue'; // 水面
import HouseForm from './house-form/house-form.vue'; // 建筑物
import FacilityForm from './facility-form/facility-form.vue'; // 设备设施
import OtherForm from './other-form/other-form.vue'; // 其他
import Bus from '../../../transaction-pro/bus.js';

export default {
  props: ['projectInfo', 'type', 'bidGeneralSituation', 'assetsmassifs'],
  components: {
    LandForm,
    sihuangForm,
    WoodsForm,
    OtherForm,
    WaterForm,
    FacilityForm,
    HouseForm
  },
  data() {
    return {
      moduleShowFlag: {
        land: false,
        sihuang: false,
        woods: false,
        water: false,
        house: false,
        facility: false,
        other: false
      }
    };
  },
  watch: {
    'bidGeneralSituation': function(val) {
      val && this.cboxCheckFlag(val);
    }
  },
  mounted() {
    Bus.$on('bidGeneralSituationChange', (val) => {
      this.cboxCheckFlag(val);
    });
  },
  methods: {
    cboxCheckFlag (val) {
      val = Array.from(val);
      this.moduleShowFlag = {
        land: val.includes('1'),
        sihuang: val.includes('2'),
        woods: val.includes('3'),
        water: val.includes('4'),
        house: val.includes('5'),
        facility: val.includes('6'),
        other: val.includes('7')
      };
    },
    test() {
      let validList = [];
      let formList = ['landForm', 'sihuangForm', 'woodsForm', 'waterForm', 'houseForm', 'facilityForm', 'otherForm'];
      formList.forEach(formKey => {
        if(this.$refs[formKey] && this.$refs[formKey].test(formKey)) {
          validList.push(this.$refs[formKey].test(formKey));
        }
      });
      return new Promise((resolve, reject) => {
        Promise.all([...validList]).then(res => {
          console.log(res, '=========综合类列表保存');
          resolve({ massifs: res });
        }, () => {
          reject();
        });
      });
    }
  }
};
